import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import { CmsConfig, ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { ResetPasswordConfirmationComponent } from './reset-password-confirmation/reset-password-confirmation.component';
import { ResetPasswordFailureComponent } from './reset-password-failure/reset-password-failure.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
  declarations: [ResetPasswordComponent, ResetPasswordConfirmationComponent, ResetPasswordFailureComponent],
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    NgbModule,
    NeedAssistanceModule,
    ConfigModule.withConfig({
      cmsComponents: {
        salesAgentResetPasswordComponent: {
          component: ResetPasswordComponent,
        },
        salesAgentresetPasswordConfirmationSlot: {
          component: ResetPasswordConfirmationComponent,
        },
        salesAgentResetPasswordFailureSlot: {
          component: ResetPasswordFailureComponent,
        }
      },
    } as CmsConfig)
  ],
  providers: [
    provideOutlet({
      id: 'salesAgentresetPasswordSlot',
      position: OutletPosition.REPLACE,
      component: ResetPasswordComponent,
    }),
    provideOutlet({
      id: 'salesAgentresetPasswordConfirmationSlot',
      position: OutletPosition.REPLACE,
      component: ResetPasswordConfirmationComponent,
    }),
    provideOutlet({
      id: 'salesAgentResetPasswordFailure',
      position: OutletPosition.REPLACE,
      component: ResetPasswordFailureComponent,
    }),
  ],
})
export class AsmResetPasswordModule { }
